"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var warning_1 = __importDefault(require("warning"));
var canUseDOM_1 = __importDefault(require("./canUseDOM"));
var CORAL_ROOTS = 'coral-roots';
function getRoot(id, tagName) {
    if (id === void 0) { id = CORAL_ROOTS; }
    if (tagName === void 0) { tagName = 'div'; }
    var ror = document.getElementById(id);
    if (!ror) {
        ror = document.createElement(tagName);
        ror.id = id;
        document.body.appendChild(ror);
    }
    return ror;
}
exports.default = getRoot;
function warnSSR(componentName, propName) {
    warning_1.default(canUseDOM_1.default(), componentName + ": it seems you're using Server Side Rendering (SSR). This component uses `createPortal`, which is not available on server.\n" +
        "Here's what you can do:\n" +
        ("- Pass `null` to the component's `" + propName + "` prop if you still want to render on server, but it will be inlined.\n") +
        "- Or, don't render it after checking if environment is SSR. You can use `canUseDOM` utility function for that.");
}
exports.warnSSR = warnSSR;
